import React from "react";
import { useField } from "formik";
import { Form } from "react-bootstrap";
import _ from "lodash";
/**
 *
 * @param {string} serverError - response error from backend
 * @returns
 */
const BCTextField = ({
    controlId,
    label,
    size,
    disabled,
    maxLength,
    serverError,
    type,
    ...props
}) => {
    const [field, meta] = useField(props);
    const [touched, error] = _.at(meta, "touched", "error");

    function _renderHelperText() {
        if (touched && error) {
            return <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>;
        } else if (serverError) {
            return <small className="text-danger font-weight-bold">{serverError}</small>;
        } else {
            return null;
        }
    }

    return (
        <Form.Group controlId={controlId}>
            {label && <Form.Label>{label}</Form.Label>}
            <Form.Control
                {...field}
                {...props}
                size={size}
                type={type}
                disabled={disabled}
                isInvalid={!!serverError ? !!serverError : meta.error && meta.touched}
                isValid={!!serverError ? !serverError : !meta.error && meta.touched}
                maxLength={maxLength}
            />
            {_renderHelperText()}
        </Form.Group>
    );
};

BCTextField.defaultProps = {
    size: "md",
    label: "",
    type: "text",
    serverError: null,
    disabled: false,
    maxLength: 255
};

export default BCTextField;
